import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { BLOCKS } from "@contentful/rich-text-types";
// Services //
import { getJobs } from "../../../services/vacante.services";

// Components//
import TitleSection from "../../molecules/title-section";
import JobCard from "../../molecules/job-card/jobCard";
import Button from "../../atoms/button/button";
import { ReferenciaContenido } from "interfaces/ReferenciaContenido";
import { graphql, useStaticQuery } from "gatsby";
import ShareModal from '../../molecules/share-modal/shareModal';
import NextArrowButton from "../../atoms/next-arrow-button/nextArrowButton";
import PreviousArrowButton from "../../atoms/previous-arrow-button/previousArrowButton";
import "./CarruselVacantes.scss";
import rawToReact from "../../../utils/rawToReact";
import "slick-carousel/slick/slick.css";



// Utils //
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';
import { navigate, withPrefix } from "gatsby";


const CarruselVacantes = (props: ReferenciaContenido) => {

    console.log(props);

    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState(0);
    const [active, setActive] = useState(0);
    const [recommendedData, setRecommendedData] = useState<any[]>([]);
    const titulo = props.tituloGeneral || "Vacantes destacadas";
    const introText = props.descripcion?.json ? undefined : props.contentful_id !=="1b3EjSDi30Z6izbjL3sWLS" ? "Descubre las ofertas laborales más recientes y aumenta tus posibilidades de conexión laboral." : "";
    // Obtener lista de vancantes
    const getVacantes = async (idCity: string | null) => {
        if (props.tituloSeccion === "Transnacional"){
            await getJobs(`&typeVacancies=1`)
                .then((response) => {
                    const { data } = response.data;
                    if (data.vacantes.content.length > 0) {
                        const filteredVacancies: any = [];
                        data.vacantes.content.forEach((vacant, index) => {
                            if (index < 6) {
                                filteredVacancies.push(vacant);
                            }
                        });
                        setRecommendedData(filteredVacancies);
                    } else {
                        getVacantes("1");
                    }
                })
                .catch((err) => {
                    console.error("Error get jobs: " + err);
                });
        }else {
            await getJobs(`&city=${idCity}`)
                .then((response) => {
                    const { data } = response.data;
                    if (data.vacantes.content.length > 0) {
                        const filteredVacancies: any = [];
                        data.vacantes.content.forEach((vacant, index) => {
                            if (index < 6) {
                                filteredVacancies.push(vacant);
                            }
                        });
                        setRecommendedData(filteredVacancies);
                    } else {
                        getVacantes("1");
                    }
                })
                .catch((err) => {
                    console.error("Error get jobs: " + err);
                });

        }
    }

    useEffect(() => {
        if (slider && recommendedData.length > 0) {
            setSliderIndex(0);
        }
    }, [slider, recommendedData]);

    useEffect(() => {
        getVacantes("1");
    }, [])

    // Custom dots renderer to show max 3 dots
    const customPaging = (i: number) => (
        <button className="custom-dot">{i + 1}</button>
    );

    const CarouselGeneral = {
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: true,
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        },
        customPaging,
        appendDots: (dots: React.ReactNode[]) => {
            // Show max 3 dots
            const total = dots.length;
            if (total <= 3) return <ul>{dots}</ul>;
            const current = sliderIndex;
            let start = 0;
            if (current > 0 && current < total - 1) {
                start = current - 1;
            } else if (current >= total - 1) {
                start = total - 3;
            }
            const visibleDots = dots.slice(start, start + 3);
            return <ul>{visibleDots}</ul>;
        },
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                },
            },
        ],
    };

    const goToNext = () => {
        if (sliderIndex < slider.props.children.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const isActiveBack = () => sliderIndex !== 0;
    const isActiveNext = () => sliderIndex !== slider?.props.children.length - 3;

    const vacancyString:string = `{"typeVacancies":{"items":[{"label":"Vacantes en otros países","value":"1","name":"typeVacancies"}]},"keyWord":{"items":[]},"area":{"items":[]},"city":{"items":[]},"contract":{"items":[]},"date":{"items":[]},"jobType":{"items":[]},"region":{"items":[]},"salary":{"items":[]},"workMode":{"items":[]}}`;
    const [isOpenModalShare, setIsOpenModalShare] = useState<boolean>(false);
    const [modalReferenceNumber, setModalReferenceNumber] = useState<number>(0);

    return (
        <>
            <div className="o-carrusel-vacantes" id={"carruselVacantes"}>
                <div className={`o-carrusel-vacantes__title ${titulo !== "Vacantes destacadas" ? "o-carrusel-vacantes__titleEmpleo" : ""}`}>
                    <div>
                        <TitleSection title={titulo} introText={introText} />
                        <div className={`o-carrusel-vacantes__description ${titulo !== "Vacantes destacadas" ? "o-carrusel-vacantes__descriptionEmpleo" : ""}`}>
                        {props.descripcion?.json && contentfulRenderOptions(props.descripcion.json)}
                        </div>
                    </div>

                    {props.slickDots !== false && recommendedData.length > 3 && window.innerWidth > 768 && (
                        <div className="o-carrusel-vacantes__arrows">
                            <PreviousArrowButton canGoPrev={isActiveBack()} onClick={goToBack}/>
                            <NextArrowButton canGoNext={isActiveNext()} onClick={goToNext}/>
                            {/* <button
                                className={`o-carrusel-vacantes__arrow-button ${isActiveBack() ? "o-carrusel-vacantes__arrow-button--active" : ""}`}
                                onClick={goToBack}
                            >
                                <img src="https://images.ctfassets.net/203frbsx1z3n/mFbMZD88bkha7mZcy9wH3/6ae98b35a97219c21fa47a6c476af704/arrow_forward_FILL0_wght400_GRAD0_opsz48.png"/>
                            </button>
                            <button
                                className={`o-carrusel-vacantes__arrow-button o-carrusel-vacantes__arrow-button--right ${isActiveNext() ? "o-carrusel-vacantes__arrow-button--active" : ""}`}
                                onClick={goToNext}
                            >
                                <img src="https://images.ctfassets.net/203frbsx1z3n/mFbMZD88bkha7mZcy9wH3/6ae98b35a97219c21fa47a6c476af704/arrow_forward_FILL0_wght400_GRAD0_opsz48.png"/>
                            </button> */}
                        </div>
                    )}
                </div>
                <div className="o-carrusel-vacantes__container">
                    <div className="slider-container">
                        <Slider
                            ref={(c) => {
                                setSlider(c);
                            }}
                            {...CarouselGeneral}
                        >
                            {recommendedData?.map((data) => (
                                <div>
                                    <JobCard
                                        title={data.title}
                                        date={data.date}
                                        company={data.company}
                                        city={data.city}
                                        referenceNumber={data.referenceNumber}
                                        url={data.url}
                                        salary={data.salary}
                                        setIsOpenModalShare={setIsOpenModalShare}
                                        setModalReferenceNumber={setModalReferenceNumber}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                    <div className="o-recommended-content-section-button">
                        <div className="o-recommended-content-people-section-ofrecemos-button">
                            {props.tituloBoton && props.redireccionBoton ? (
                                <Button
                                    classname="a-button a-button__magenta primary restricted-content-modal__button gtm_ver_vacantesdestacados"
                                    type="button"
                                    text={props.tituloBoton}
                                    //href={withPrefix(props.redireccionBoton)}
                                    isDisabled={false}
                                    onClickAction={()=>{
                                        navigate(withPrefix(props.redireccionBoton));
                                        localStorage.setItem("localSelectedFilters", vacancyString )
                                    }}
                                />

                            ) : (
                                <Button
                                    classname="a-button a-button__magenta restricted-content-modal__button gtm_ver_vacantesdestacados"
                                    type="link"
                                    text="Conoce las vacantes"
                                    href="/servicio-de-empleo/personas/vacantes-en-antioquia/"
                                    isDisabled={false}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {isOpenModalShare && (
                <ShareModal
                    isOpen
                    link={`https://www.comfama.com/servicio-de-empleo/personas/vacantes-en-antioquia/vacante/?id=${modalReferenceNumber}`}
                    onClose={() => setIsOpenModalShare(false)}
                />
            )}
        </>
    );
};

export default CarruselVacantes;
